import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route
} from 'react-router-dom'

import * as serviceWorker from './serviceWorker'
import './index.css'
import 'bootstrap/dist/css/bootstrap.min.css'

import Login from './components/Login/Login'
import AdminPanel from './components/AdminPanel/AdminPanel'

ReactDOM.render(
  <Router>
    <Route path='/' component={Login} exact />
    <Route path='/admin' component={AdminPanel} />
  </Router>,
  document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
